var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb-item"},_vm._l((_vm.itemList),function(item){return _c('div',{key:item.path,class:{ clickable: item.path },on:{"click":function($event){return _vm.toPath(item)}}},[_c('span',[_vm._v(_vm._s(item.name || item))]),_vm._v(" "),_c('span',{staticClass:"separator"},[_vm._v("/")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-532685f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/breadcrumbItem/index.vue
// module id = null
// module chunks = 